import { defineComponent as _defineComponent } from 'vue'
import { computed, onMounted, ref } from 'vue';
import axios from 'axios';
import eventBus from '@/foundations/services/eventBus';
import type { SuggestedArticle } from '@ilteducation/article-publisher-types';
import config from '../../config/ConfigProvider';


export default /*#__PURE__*/_defineComponent({
  __name: 'SuggestedArticlesDataTable',
  setup(__props) {

const suggestedArticles = ref<SuggestedArticle[]>([]);
const isLoading = ref(false);
const loadingArticleId = ref<string | null>(null);
const selectedPublishers = ref<string[]>([]);

const availablePublishers = computed(() =>
  [...new Set(suggestedArticles.value.map((a) => a.publisher).filter(Boolean))].sort(),
);

const filteredArticles = computed(() =>
  selectedPublishers.value.length === 0
    ? suggestedArticles.value
    : suggestedArticles.value.filter((a) => selectedPublishers.value.includes(a.publisher)),
);

const headers = [
  { text: 'Title', value: 'title', sortable: false },
  { text: 'Publisher', value: 'publisher' },
  { text: 'Published At', value: 'publishedAt' },
  { text: 'Status', value: 'status' },
  { text: 'Created', value: 'createdAt' },
  { text: 'Actions', value: 'actions', sortable: false },
];

const fetchSuggestedArticles = async () => {
  try {
    isLoading.value = true;
    const response = await axios.get(`${config.value('theArticlePublisherUrl')}/suggested-articles`);
    suggestedArticles.value = response.data.data;
  } catch (error) {
    console.error('Error fetching suggested articles:', error);
    eventBus.$emit('snackbarV2.open', { text: 'Error fetching suggested articles', color: 'error' });
  } finally {
    isLoading.value = false;
  }
};

const handleAccept = async (article: SuggestedArticle) => {
  try {
    loadingArticleId.value = article.id;

    // Call the backend endpoint that handles all the orchestration
    const response = await axios.post(
      `${config.value('theArticlePublisherUrl')}/suggested-articles/${article.id}/accept`,
    );
    const { articleId } = response.data;

    // Update the local article status
    const index = suggestedArticles.value.findIndex((a: SuggestedArticle) => a.id === article.id);
    if (index !== -1) {
      suggestedArticles.value[index].status = 'accepted';
    }

    eventBus.$emit('snackbarV2.open', {
      text: `Successfully created article: ${article.title}`,
      color: 'success',
    });
  } catch (error) {
    console.error('Error processing article:', error);
    eventBus.$emit('snackbarV2.open', {
      text: 'Error processing article',
      color: 'error',
    });
  } finally {
    loadingArticleId.value = null;
  }
};

const handleDecline = async (article: SuggestedArticle) => {
  try {
    loadingArticleId.value = article.id;
    const response = await axios.patch(`${config.value('theArticlePublisherUrl')}/suggested-articles/${article.id}`, {
      status: 'rejected',
    });

    // Update the local article status
    const index = suggestedArticles.value.findIndex((a: SuggestedArticle) => a.id === article.id);
    if (index !== -1) {
      suggestedArticles.value.splice(index, 1, response.data);
    }

    eventBus.$emit('snackbarV2.open', {
      text: `Successfully declined: ${article.title}`,
      color: 'success',
    });
  } catch (error) {
    console.error('Error declining article:', error);
    eventBus.$emit('snackbarV2.open', {
      text: 'Error declining article',
      color: 'error',
    });
  } finally {
    loadingArticleId.value = null;
  }
};

onMounted(() => {
  fetchSuggestedArticles();
});

return { __sfc: true,suggestedArticles, isLoading, loadingArticleId, selectedPublishers, availablePublishers, filteredArticles, headers, fetchSuggestedArticles, handleAccept, handleDecline }
}

})